import { use } from 'react';
import CalendarModeContext from '@/contexts/CalendarMode/CalendarModeContext';
import { CalendarMode, DEFAULT_CALENDAR_MODE } from '@/helpers/calendarMode';

const NOOP: (mode: CalendarMode) => void = () => undefined;

/**
 * Shared לועזי|עברי preference. Inside CalendarModeProvider the toggle and the
 * date cells read the same value. Outside it (other boards, tests) the default
 * is Gregorian-primary and setters are ignored.
 */
const useCalendarMode = (): [CalendarMode, (mode: CalendarMode) => void] => {
  return use(CalendarModeContext) ?? [DEFAULT_CALENDAR_MODE, NOOP];
};

export default useCalendarMode;
